import React from 'react';
import { LeftTop, Title, HB } from './style'
import { Table, Tooltip } from 'antd'
import styled from 'styled-components';

const TableContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  max-height: 310px;
`;
const LeftDiv = styled.div`
  width: calc(50% - 5px);
  background-color: #fff;
  border-radius: 12px;
`;
export default (props) => {
  const { suggestGroupList, similarGroupList } = props.response;
  const columns = [
    {
      title: '编码',
      dataIndex: 'dipDiseGrpCode',
      key: 'dipDiseGrpCode',
      width: 140
    },
    {
      title: '入组',
      dataIndex: 'dipDiseGrpName',
      key: 'dipDiseGrpName',
      ellipsis: true,
      render: (text) => (
        <Tooltip title={text}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    // {
    //   title: '主诊断',
    //   dataIndex: 'grpDiagCode',
    //   width: 100,
    //   key: 'grpDiagCode',
    // },
    {
      title: '倍率',
      dataIndex: 'rate',
      key: 'rate',
      width: 70,
      render: (text) => {
        return !isNaN(text) ? text.toFixed(2) : '0.00';
      }
    },
    {
      title: '盈亏金额',
      dataIndex: 'proLosAmount',
      key: 'proLosAmount',
      width: 80,
      render: (text) => {
        return !isNaN(text) ? text.toFixed(2) : '0.00';
      }
    },
    {
      title: '预测费用',
      dataIndex: 'predictedAmount',
      key: 'predictedAmount',
      width: 80,
      render: (text) => {
        return !isNaN(text) ? text.toFixed(2) : '0.00';
      }
    },
    {
      title: '分值',
      dataIndex: 'scoAdjm',
      key: 'scoAdjm',
      width: 70,
      render: (text) => {
        return !isNaN(text) ? text.toFixed(2) : '0.00';
      }
    }
  ];

  return (
    <TableContainer>
      <LeftDiv>
        <LeftTop>
          <HB />
          <Title style={{ fontSize: '16px' }}>推荐入组</Title>
        </LeftTop>
          <Table
            rowKey='dipDiseGrpCode'
            size="small"
            pagination={false}
            scroll={{ y: 220 }}
            bordered columns={columns} dataSource={suggestGroupList} style={{ marginTop: '10px' }} />
      </LeftDiv>
      <LeftDiv>
        <LeftTop>
          <HB />
          <Title style={{ fontSize: '16px' }}>相似入组</Title>
        </LeftTop>
          <Table
            rowKey='dipDiseGrpCode'
            size="small"
            pagination={false}
            bordered
             columns={columns}
              dataSource={similarGroupList}
               style={{ marginTop: '10px' }}
               scroll={{ y: 220 }}
                />
      </LeftDiv>
    </TableContainer>

  );
};

